import Axios from "../../Config/API";
import {
    ModuloInterface,
    VincularGrupoModuloInterface,
} from "../../../Interfaces/Geral/Grupos/GruposModulosInterfaces";
import Service from "../../Service";

export async function ListarGruposComModulosService() {
    return Service(Axios.get(`/home/gruposmodulos/listargruposcommodulos`));
}

export async function ListarModulosVinculadosPorGrupoService(iDGrupo: number) {
    return Service(
        Axios.get<Array<ModuloInterface>>(
            `/home/gruposmodulos/listarmodulosvinculadosporgrupo?IDGrupo=${iDGrupo}`
        )
    );
}

export async function ListarModulosNaoVinculadosPorGrupoService(
    iDGrupo: number
) {
    return Service(
        Axios.get(
            `/home/gruposmodulos/listarmodulosnaovinculadosporgrupo?IDGrupo=${iDGrupo}`
        )
    );
}

export async function DesvincularGrupoModuloService(IDGrupoModulo: number) {
    return Service(
        Axios.delete(
            `/home/gruposmodulos/desvinculargrupomodulo?IDGrupoModulo=${IDGrupoModulo}`
        )
    );
}

export async function VincularGrupoModuloService(
    props: VincularGrupoModuloInterface
) {
    return Service(
        Axios.post(`/home/gruposmodulos/vinculargrupomodulo`, props)
    );
}
